import { createContext } from 'react';

export interface DraggableListContextValue {
  draggedId: string | null;
}

const DraggableListContext = createContext<DraggableListContextValue>({
  draggedId: null,
});

export default DraggableListContext;
